/**
 * DidiJSBridge 封装
 *
 */
import {
    each,
    isUndefined,
    isStr,
    isFn,
    noop,
    getWindow
} from '../util';
let theWindow = getWindow();

import {
    supportPrompt,
    promptSend
} from './old_prompt';

import {
    alias
} from '../global-api/alias';

let cbs = [];

function init() {
    let bridge = theWindow.DidiJSBridge;
    if (isUndefined(bridge)) {
        document.addEventListener('DidiJSBridgeReady', onBridgeReady, false);
    } else {
        bridge.init && bridge.init();
    }
}

function onBridgeReady() {
    let bridge = theWindow.DidiJSBridge;
    bridge.init && bridge.init();

    each(cbs, function (cb) {
        cb(bridge);
    });
}

init();

export function bridgeReady(callback) {
    let bridge = theWindow.DidiJSBridge;
    if (isUndefined(bridge)) {
        cbs.push(callback);
    } else {
        // 注册回调事件
        callback(bridge);
    }
}

export function oldMakeBridgeFn(name, conf, allConf) {
    return function (param = '', callback = noop) {
        if (arguments.length === 1 && isFn(param)) {
            callback = param;
            param = '';
        }

        // 低版本bridge alias param alias处理
        let nameParams = alias(name, param, conf, allConf);

        if (supportPrompt()) {
            promptSend(nameParams.name, nameParams.param, callback);
        } else {
            bridgeReady((bridge) => {
                bridge.callHandler(nameParams.name, nameParams.param, (data) => {
                    // 兼容data是字符串的情况
                    if (isStr(data)) {
                        data = JSON.parse(data);
                    }
                    callback(null, data);
                });
            });
        }
    };
};

export function registerHandler(fn, callback) {
    bridgeReady((bridge) => {
        bridge.registerHandler(fn, callback);
    });
};



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/core/old_bridge.js